export var SituationType;
(function (SituationType) {
    SituationType["OPEN"] = "1";
    SituationType["PAID"] = "2";
    SituationType["CANCELED"] = "3";
    SituationType["TITLE_TRANSFERRED"] = "5";
    SituationType["LATE"] = "7";
})(SituationType || (SituationType = {}));
//# sourceMappingURL=card-payment-summary-type.js.map